<template>
    <div class="itemCard">
        <div class="itemCard__header">
            <span class="itemCard__id">#{{ id }}</span>
            <select v-model="selectCategory" class="itemCard__category" required>
                <option disabled value="">Seleccione una categoría</option>
                <option v-for="item in availableItems" :key="item.id" :value="item.id">
                    {{ item.name }}
                </option>
            </select>
        </div>

        <div class="itemCard__block">
            <span class="itemCard__label">Precio</span>
            <div class="priceSection">
                <input v-model.number="priceProxy" type="number" step="0.01" min="0" placeholder="Precio" required>
                <div class="priceSection__check">
                    <label for="ivaAdd">Precio con IVA incluido</label>
                    <input v-model="ivaAddedProxy" type="checkbox" id="ivaAdd" name="ivaAdd"/>
                </div>
            </div>
        </div>

        <div class="itemCard__block">
            <span class="itemCard__label">Cantidad</span>
            <input v-model.number="amountProxy" type="number" step="1" min="0" placeholder="Cantidad" required>
        </div>

        <div class="itemCard__block">
            <span class="itemCard__label">Impuestos</span>
            <div class="taxtSection">
                <div class="taxtSection__inputs">
                    <input v-model.number="ivaProxy" type="number" step="0.01" min="0" placeholder="IVA %">
                    <input v-model.number="reteFuenteProxy" type="number" step="0.01" min="0" placeholder="Retefuente %">
                    <input v-model.number="reteIcaProxy" type="number" step="0.01" min="0" placeholder="Reteica %">
                </div>
                <div class="taxtSection__summary">
                    <p class="text">Precio base: {{ baseValueDisplay }}</p>
                    <p class="text">IVA: {{ ivaValueDisplay }}</p>
                    <p class="text">Rete fuente: {{ reteFuenteValueDisplay }}</p>
                    <p class="text">Rete ica: {{ reteIcaValueDisplay }}</p>
                    <p class="text text--total">Valor total: {{ totalValueDisplay }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formatCurrencyRAE } from '@/utils/numberFormat';

export default {
    name: "itemCalculate",
    props: {
        id: { type: [String, Number], required: false, default: null },
        ivaAdded: { type: Boolean, required: false, default: true },
        category: { type: [String, Number], required: false, default: "" },
        availableItems: { type: Array, required: false, default: () => [] },
        price: { type: [String, Number], required: false, default: 0},
        base: { type: [String, Number], required: false, default: 0},
        iva: { type: [String, Number], required: false, default: 0},
        reteFuente: { type: [String, Number], required: false, default: 0},
        reteIca: { type:[String, Number], required: false, default: 0},
        amount: { type: [String, Number], required: false, default: 1},
    },
    emits: [
    "update:price",
    "update:base",
    "update:iva",
    "update:reteFuente",
    "update:reteIca",
    "update:amount",
    "update:valores",
    "update:category"
    ],
    watch: {
        baseValue() {
            this.emitValores();
            this.$emit("update:base", Number(this.baseValue));
        },
        ivaValue() { this.emitValores() },
        reteFuenteValue() { this.emitValores() },
        reteIcaValue() { this.emitValores() },
        totalValue() { this.emitValores() },
        selectCategory() { this.emitValores() },
    },
    methods: {
        emitValores() {
        this.$emit("update:valores", {
            valor: Number(this.baseValue),
            ivaValue: Number(this.ivaValue),
            reteFuenteValue: Number(this.reteFuenteValue),
            reteicaValue: Number(this.reteIcaValue),
            totalValue: Number(this.totalValue),
            category: this.selectCategory
        });
        }
    },
    computed: {
        priceProxy: {
            get() { return this.price },
            set(value) { this.$emit("update:price", value) }
        },
        ivaAddedProxy: {
            get() { return this.ivaAdded },
            set(value) { this.$emit('update:ivaAdded', value) }
        },
        ivaProxy: {
            get() { return this.iva },
            set(value) { this.$emit("update:iva", value) }
        },
        reteFuenteProxy: {
            get() { return this.reteFuente },
            set(value) { this.$emit("update:reteFuente", value) }
        },
        reteIcaProxy: {
            get() { return this.reteIca },
            set(value) { this.$emit("update:reteIca", value) }
        },
        amountProxy: {
            get() { return this.amount },
            set(value) { this.$emit("update:amount", value) }
        },
        selectCategory: {
            get() { return this.category },
            set(value) { this.$emit("update:category", value) }
        },
        baseValue() {
            const price = parseFloat(this.price) || 0;
            const iva = parseFloat(this.iva) || 0;
            return this.ivaAdded ? price / (1 + iva / 100) : price;
        },
        ivaValue() {
            const base = this.baseValue;
            const iva = parseFloat(this.iva) || 0;
            return base * (iva / 100);
        },
        reteFuenteValue() {
            const base = this.baseValue;
            const reteFuente = parseFloat(this.reteFuente) || 0;
            return base * (reteFuente / 100);
        },
        reteIcaValue() {
            const base = this.baseValue;
            const reteIca = parseFloat(this.reteIca) || 0;
            return base * (reteIca / 100);
        },
        totalValue() {
            return this.baseValue + this.ivaValue - this.reteFuenteValue - this.reteIcaValue;
        },
        baseValueDisplay()       { return formatCurrencyRAE(this.baseValue); },
        ivaValueDisplay()        { return formatCurrencyRAE(this.ivaValue); },
        reteFuenteValueDisplay() { return formatCurrencyRAE(this.reteFuenteValue); },
        reteIcaValueDisplay()    { return formatCurrencyRAE(this.reteIcaValue); },
        totalValueDisplay()      { return formatCurrencyRAE(this.totalValue); },
    },
};
</script>

<style scoped>
.itemCard {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 0.75rem;
    padding: 1rem;
    border: 1px solid #9DB2BF;
    border-radius: 8px;
    background-color: #fafbfc;
    margin-bottom: 1rem;
}
.itemCard__header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.75rem;
}
.itemCard__id {
    display: inline-block;
    background-color: #2c3e50;
    color: #ffffff;
    font-weight: 600;
    font-size: 0.85rem;
    padding: 0.25rem 0.6rem;
    border-radius: 999px;
    line-height: 1;
    min-width: 2.25rem;
    text-align: center;
}
.itemCard__category {
    flex: 1;
    height: 2.25rem;
    margin: 0;
}
.itemCard__block {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    padding-top: 0.5rem;
    border-top: 1px dashed #d6dee6;
}
.itemCard__block:first-of-type {
    border-top: none;
    padding-top: 0;
}
.itemCard__label {
    font-size: 0.8rem;
    font-weight: 600;
    color: #2c3e50;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}
input {
    margin: 0;
    height: 2rem;
    padding: 0 0.5rem;
    border: 1px solid #cbd5dd;
    border-radius: 4px;
    box-sizing: border-box;
}
select {
    height: 2.25rem;
    padding: 0 0.5rem;
    border: 1px solid #cbd5dd;
    border-radius: 4px;
    box-sizing: border-box;
}
.priceSection {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 0.75rem;
}
.priceSection > input {
    flex: 1;
}
.priceSection__check {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.9rem;
    color: #2c3e50;
}
.priceSection__check input[type="checkbox"] {
    height: auto;
    width: auto;
    margin: 0;
}
.taxtSection {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;
}
.taxtSection__inputs {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    width: 45%;
}
.taxtSection__inputs input {
    width: 100%;
}
.taxtSection__summary {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 50%;
}
.taxtSection__summary p {
    font-size: 0.9rem;
    margin: 0;
    color: #2c3e50;
}
.text--total {
    font-weight: 700;
    font-size: 1rem !important;
    margin-top: 0.35rem !important;
    border-top: 1px solid #d6dee6;
    padding-top: 0.35rem;
}

@media (max-width: 768px) {
    .priceSection {
        flex-direction: column;
        align-items: stretch;
    }
    .taxtSection {
        flex-direction: column;
    }
    .taxtSection__inputs,
    .taxtSection__summary {
        width: 100%;
        align-items: stretch;
    }
    .taxtSection__summary {
        align-items: flex-end;
    }
}
</style>
